import React, { createContext, useEffect, useState } from "react";
import { NamedProperty } from "sprint-common-web";

import { AspectRatiosResponse } from "../../api/master-api/lookups/AspectRatiosResponse";
import { useMasterLookupsApi } from "../../api/master-api/lookups/useMasterLookupsApi";

interface IAspectRatiosDataContext {
    aspectRatios: AspectRatio[];
    isLoading: boolean;
}

export type AspectRatio = NamedProperty;

export const AspectRatiosDataContext = createContext<IAspectRatiosDataContext>({} as IAspectRatiosDataContext);

type AspectRatiosDataProviderProps = React.PropsWithChildren<unknown>;

export const AspectRatiosDataProvider: React.FunctionComponent<AspectRatiosDataProviderProps> = ({
    children
}: AspectRatiosDataProviderProps) => {
    const [aspectRatios, setAspectRatios] = useState<AspectRatio[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { getAspectRatios } = useMasterLookupsApi();

    useEffect(() => {
        setIsLoading(true);
        getAspectRatios().then((response: AspectRatiosResponse) => {
            setAspectRatios(response.items);
            setIsLoading(false);
        });
    }, []);

    return (
        <AspectRatiosDataContext.Provider value={{ aspectRatios, isLoading }}>
            {children}
        </AspectRatiosDataContext.Provider>
    );
};
